import { Icon } from '@user-portal/wikr-components';
import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import * as S from './styled';

const WorkoutsContainer = ({
    children,
    withBackButton,
    trackOnBack,
    testId,
}: {
    children: ReactNode;
    withBackButton?: boolean;
    trackOnBack?: () => void;
    testId?: string;
}) => {
    const navigate = useNavigate();

    const onBack = () => {
        trackOnBack?.();
        navigate(-1);
    };

    return (
        <S.WorkoutsContainer data-testid={testId}>
            {withBackButton && (
                <S.BackButton onClick={onBack} data-testid="workouts-back-button">
                    <Icon name="arrowLeft" />
                </S.BackButton>
            )}

            {children}
        </S.WorkoutsContainer>
    );
};

export default WorkoutsContainer;
